import React from "react";
import { alpha, ButtonBase, Typography, useTheme } from "@mui/material";

/** Pages with numbers */
export const ButtonPages = ({
  onClick,
  disabled = false,
  children,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={{
        mx: 0.2,
        minWidth: 18,
        height: 19,
        borderRadius: "4px",
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease-in-out",
        border: `1px solid ${theme.palette.divider}`,
        "&:hover": {
          backgroundColor: alpha(theme.palette.secondary.light, 0.4),
          scale: 1.1,
        },
        ...sx,
      }}
      {...props}
    >
      <Typography fontSize={10} fontWeight={600}>
        {children}
      </Typography>
    </ButtonBase>
  );
};
/** Section navigation */
export const ArrowPages = ({ onClick, disabled = false, icon, ...props }) => {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      sx={{
        minWidth: 18,
        height: 19,
        borderRadius: "4px",
        mx: 0.2,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: alpha(theme.palette.secondary.light, 0.1),
          scale: 1.1,
        },
      }}
      {...props}
    >
      <Typography
        fontSize={20}
        fontWeight={600}
        mb={0.5}
        color={alpha(theme.palette.secondary.light, disabled ? 0.2 : 1)}
      >
        {icon}
      </Typography>
    </ButtonBase>
  );
};
